import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedService: JSON.parse(localStorage.getItem('selectedService')) || null,
  deliveryLocation: JSON.parse(localStorage.getItem('deliveryLocation')) || null,
  selectedAddress: JSON.parse(localStorage.getItem('selectedAddress')) || null,
};

const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setSelectedService: (state, action) => {
      state.selectedService = action.payload;
      localStorage.setItem('selectedService', JSON.stringify(action.payload));
    },
    setDeliveryLocation: (state, action) => {
      state.deliveryLocation = action.payload;
      localStorage.setItem('deliveryLocation', JSON.stringify(action.payload));
    },
    setSelectedAddress: (state, action) => {
      state.selectedAddress = action.payload;
      localStorage.setItem('selectedAddress', JSON.stringify(action.payload));
    },
    clearSession: (state) => {
      state.selectedService = null;
      state.deliveryLocation = null;
      state.selectedAddress = null;
      localStorage.removeItem('selectedService');
      localStorage.removeItem('deliveryLocation');
      localStorage.removeItem('selectedAddress');
    },
  },
});

export const { setSelectedService, setDeliveryLocation, setSelectedAddress, clearSession } = sessionSlice.actions;

export const selectSelectedService = (state) => state.session.selectedService;
export const selectDeliveryLocation = (state) => state.session.deliveryLocation;
export const selectSelectedAddress = (state) => state.session.selectedAddress;

export default sessionSlice.reducer;
